import React from 'react';

export default function NoMatch() {
  return(
    <h2 >No Match</h2>
  );
}